import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Linkedin } from "lucide-react";
import { navigation, contactInfo } from "../../data/mock";

const Footer = () => {
  return (
    <footer className="relative border-t border-border/5 bg-card pt-16 pb-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/assets/qp-logo.png" alt="Quality Power logo" className="w-9 h-9 object-contain" />
              <span className="font-display font-semibold tracking-wide text-foreground text-base">QUALITY POWER</span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs mb-5">
              High voltage electrical equipment and solutions for electrical grid connectivity and energy
              transition — spanning HVDC, FACTS, transmission, distribution and automation.
            </p>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground">
              <span className="flex items-start gap-2">
                <MapPin size={16} className="text-qcyan mt-0.5 shrink-0" /> {contactInfo.addressLine}
              </span>
              <a href={`tel:${contactInfo.phone}`} className="flex items-center gap-2 hover:text-qcyan transition-colors">
                <Phone size={16} className="text-qcyan shrink-0" /> {contactInfo.phone}
              </a>
              <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2 hover:text-qcyan transition-colors">
                <Mail size={16} className="text-qcyan shrink-0" /> {contactInfo.email}
              </a>
            </div>
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Quality Power on LinkedIn"
              className="inline-flex items-center justify-center w-9 h-9 rounded-md border border-border/10 mt-5 text-muted-foreground hover:text-qcyan hover:border-qcyan/40 transition-colors"
            >
              <Linkedin size={16} />
            </a>
          </div>

          {navigation.slice(0, 4).map((item) => (
            <div key={item.label}>
              <h4 className="text-foreground font-semibold text-sm tracking-wide uppercase mb-4">{item.label}</h4>
              <ul className="flex flex-col gap-2.5">
                {(item.items || [{ label: "Overview", to: item.to }]).map((sub) => (
                  <li key={sub.label}>
                    <Link to={sub.to} className="text-sm text-muted-foreground hover:text-qcyan transition-colors">
                      {sub.label}
                    </Link>
                  </li>
                ))}
                {item.to === "/footprint" && (
                  <li>
                    <Link to="/OnlineReferences" className="text-sm text-muted-foreground hover:text-qcyan transition-colors">
                      Online References
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-foreground font-semibold text-sm tracking-wide uppercase mb-4">Investors</h4>
            <ul className="flex flex-col gap-2.5">
              {navigation[5].items.map((sub) => (
                <li key={sub.label}>
                  <Link to={sub.to} className="text-sm text-muted-foreground hover:text-qcyan transition-colors">
                    {sub.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-qcyan transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-border/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Quality Power Electrical Equipments Limited. All rights reserved.</p>
          <p className="text-xs text-muted-foreground">BSE & NSE Listed · CIN available on request</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
